import React from 'react'
import { PRIVACY_POLICY_HREF, TERMS_AND_CONDITIONS_HREF } from 'constants/global'
import { Trans } from 'react-i18next'

export enum TermsAndPolicyType {
  WELCOME = 'agreeTermsWelcome',
  WELCOME_PARENT = 'agreeTermsWelcomeParent',
  WELCOME_YOU_AND_PARENT = 'agreeTermsWelcomeYouAndParent',
  ACTIVATION = 'agreeTermsActivation',
}

interface Props {
  type: TermsAndPolicyType

  className?: string
}

const TermsAndPolicy = ({ type, className = '' }: Props) => {
  return (
    <p className={className}>
      <Trans ns='strRegister' i18nKey={type}>
        By creating an account, you agree to{' '}
        <a target='_blank' rel='noopener noreferrer' href={PRIVACY_POLICY_HREF}>
          ITF Privacy Policy
        </a>{' '}
        and{' '}
        <a target='_blank' rel='noopener noreferrer' href={TERMS_AND_CONDITIONS_HREF}>
          ITF World Tennis Number Terms & Conditions
        </a>
      </Trans>
    </p>
  )
}

export default TermsAndPolicy
